import { Background, BackgroundVariant, Controls, MiniMap, ReactFlow } from '@xyflow/react';
import type { Connection, Edge, EdgeChange, IsValidConnection, Node, NodeChange, ReactFlowProps } from '@xyflow/react';
import type { DragEvent } from 'react';
import '@/widgets/definitions';
import { DeletableEdge } from '@/components/flow-editor/edges/deletable-edge';
import { widgetRegistry } from '@/widgets/registry';
import type { WidgetNodeData } from '@/widgets/types';

const nodeTypes = widgetRegistry.getNodeTypes();

const edgeTypes = { deletable: DeletableEdge };

const defaultEdgeOptions = {
  type: 'deletable',
  style: { stroke: 'var(--mantine-primary-color-filled)', strokeWidth: 2 },
  animated: true,
};

type FlowCanvasProps = {
  nodes: Node<WidgetNodeData>[];
  edges: Edge[];
  onNodesChange: (changes: NodeChange<Node<WidgetNodeData>>[]) => void;
  onEdgesChange: (changes: EdgeChange<Edge>[]) => void;
  onConnect: (connection: Connection) => void;
  isValidConnection: IsValidConnection;
  onNodeClick: ReactFlowProps<Node<WidgetNodeData>>['onNodeClick'];
  onPaneClick: () => void;
  onDragOver: (event: DragEvent) => void;
  onDrop: (event: DragEvent) => void;
};

export function FlowCanvas({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onConnect,
  isValidConnection,
  onNodeClick,
  onPaneClick,
  onDragOver,
  onDrop,
}: FlowCanvasProps) {
  return (
    <ReactFlow
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
      isValidConnection={isValidConnection}
      onNodeClick={onNodeClick}
      onPaneClick={onPaneClick}
      onDragOver={onDragOver}
      onDrop={onDrop}
      nodeTypes={nodeTypes}
      edgeTypes={edgeTypes}
      fitView
      snapToGrid
      snapGrid={[15, 15]}
      defaultEdgeOptions={defaultEdgeOptions}
      proOptions={{ hideAttribution: true }}
    >
      <Controls />
      <MiniMap
        nodeColor={() => 'var(--mantine-primary-color-filled)'}
        maskColor="rgba(0, 0, 0, 0.5)"
        style={{ background: 'var(--mantine-color-body)' }}
      />
      <Background variant={BackgroundVariant.Dots} gap={20} size={1} color="var(--mantine-color-dimmed)" />
    </ReactFlow>
  );
}
